import React, { Component } from 'react'
import { Link } from 'react-router'
import { HeaderView } from '@merchant-backend/common-components'
import List from './List'
import store from './store'
import { DatePicker } from 'hljd'
import { toJS } from 'mobx'
import { LIVE_MANAGE_PATH } from '@constant'

const { RangePicker } = DatePicker
export default class extends Component {
  render() {
    const header = [<Link to={LIVE_MANAGE_PATH}>视频直播</Link>, '充值记录']
    const { date } = store
    return (
      <HeaderView title="充值记录" header={header}>
        <RangePicker
          value={toJS(date)}
          style={{ width: 240, margin: '20px 0 30px 0' }}
          onChange={store.changeParams}
        />
        <List />
      </HeaderView>
    )
  }
}
